import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import classNames from 'classnames';
import styles from './styles.module.scss';

const ColumnHeader = ({ columns, className }) => (
  <Grid
    container
    className={classNames(styles.columnHeaderContainer, className)}
    alignContent='center'
    alignItems='center'
  >
    {columns.map((col, ind) => (
      <Grid
        item
        // eslint-disable-next-line react/no-array-index-key
        key={ind}
        xs={col.size || 3}
        style={{ textAlign: col.center ? 'center' : 'initial' }}
      >
        {col.label}
      </Grid>
    ))}
  </Grid>
);

ColumnHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  className: PropTypes.string
};

ColumnHeader.defaultProps = {
  className: null
};

export default ColumnHeader;
